import { MutingVideo } from "@/components/shared/muting-media";
import { LeftPaneDialog } from "./left-panel";
import { RecordingStarterModal } from "./recording-starter";
import { RecordingStateActions } from "./recording-state-actions";

interface RecordingPanelProps {
  showDeviceModal: boolean;
  videoDeviceId: string;
  audioDeviceId: string;
  setVideoDeviceId: (id: string) => void;
  setAudioDeviceId: (id: string) => void;
  handleStartRecording: () => Promise<void>;
  devicesByType: any;
  currentRecording: any;
  countdown: number | null;
  isReplayMode: boolean;
  recording: boolean;
  duration: number;
  isPaused: boolean;
  handleStopRecording: () => Promise<void>;
  handlePauseResumeRecording: () => Promise<void>;
  handleDownload: () => void;
  handleSend: () => void;
  handleRecordAgain: () => Promise<void>;
  videoUrl?: string | null;
  canUpdateMentorships: boolean;
}

export const RecordingPanel = ({
  showDeviceModal,
  videoDeviceId,
  audioDeviceId,
  setVideoDeviceId,
  setAudioDeviceId,
  handleStartRecording,
  devicesByType,
  currentRecording,
  countdown,
  isReplayMode,
  recording,
  duration,
  isPaused,
  handleStopRecording,
  handlePauseResumeRecording,
  handleDownload,
  handleSend,
  handleRecordAgain,
  videoUrl,
  canUpdateMentorships,
}: RecordingPanelProps) => {
  const formatDuration = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };

  return (
    <>
      {!videoUrl && canUpdateMentorships && (
        <LeftPaneDialog open={showDeviceModal}>
          <RecordingStarterModal
            videoDeviceId={videoDeviceId}
            setVideoDeviceId={setVideoDeviceId}
            audioDeviceId={audioDeviceId}
            setAudioDeviceId={setAudioDeviceId}
            handleStartRecording={handleStartRecording}
            devicesByType={devicesByType}
            canUpdateMentorships={canUpdateMentorships}
          />
        </LeftPaneDialog>
      )}

      <div className="relative h-full">
        {videoUrl ? (
          <MutingVideo
            key={videoUrl}
            controls
            playsInline
            className="h-full w-full object-cover"
            src={videoUrl}
          />
        ) : (
          currentRecording ? (
            <>
              {countdown && (
                <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform">
                  <div className="flex h-48 w-48 items-center justify-center rounded-full bg-black/50">
                    <span className="text-9xl font-bold text-white">
                      {countdown}
                    </span>
                  </div>
                </div>
              )}
              {isReplayMode ? (
                <MutingVideo
                  key={currentRecording.id}
                  ref={currentRecording.previewRef}
                  controls
                  playsInline
                  className="h-full w-full object-cover"
                  src={
                    currentRecording.blob
                      ? URL.createObjectURL(currentRecording.blob)
                      : undefined
                  }
                />
              ) : (
                <video
                  ref={currentRecording.webcamRef}
                  playsInline
                  muted
                  className="h-full w-full object-cover"
                />
              )}
              {recording && (
                <span className="absolute right-4 top-4 rounded-lg bg-black/50 px-3 py-1 text-white">
                  {formatDuration(duration)}
                </span>
              )}
              <RecordingStateActions
                currentRecording={currentRecording}
                recording={recording}
                isPaused={isPaused}
                handleStopRecording={handleStopRecording}
                handlePauseResumeRecording={handlePauseResumeRecording}
                handleDownload={handleDownload}
                handleSend={handleSend}
                handleRecordAgain={handleRecordAgain}
                canUpdateMentorships={canUpdateMentorships}
              />
            </>
          ) : !canUpdateMentorships ? (
            <div className="flex h-full items-center justify-center p-6 text-center text-white">
              You do not have permission to create mentor monthly updates.
            </div>
          ) : null
        )}
      </div>
    </>
  );
};
